// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"385df9b5","501":"2baaaec2"}[chunkId] + ".chunk.css";
};